import axios from 'axios'
import { REACT_APP_API } from '../../../config'

export async function getDictionaryCarlots() {
  const response = await axios.get(
    `${REACT_APP_API}/dictionary/getAllCarLots/`)
  const rawCarlots = response?.data
  const carLots = rawCarlots
    ?.filter(carlot => carlot.concesionaria)
    .map(rawCarlot => {
      const carLotName = rawCarlot.concesionaria
      return {
        label: carLotName,
        value: carLotName
      }
    })
  return carLots
}